import { Appearance, loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { STRIPE_PUBLISHABLE_KEY } from "src/config";
import { usePostCreateCheckout } from "src/networking/terminals";
import { atomDossier, atomPolicy } from "src/storage";

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

const appearance: Appearance = {
  variables: {
    colorPrimary: "#00686f",
  },
};

export const useDataEntryStep5 = () => {
  const [clientSecret, setClientSecret] = useState<string | null>(null);
  const policy = useRecoilValue(atomPolicy);
  const dossier = useRecoilValue(atomDossier);
  const { crossGate: postCreateCheckout } = usePostCreateCheckout();

  useEffect(() => {
    if (!dossier?.dossierId || !policy?.idPolizza) return;

    postCreateCheckout(
      {
        headers: {
          xDossierId: dossier.dossierId,
        },
        uriParams: {
          idPolizza: policy.idPolizza,
        },
      },
      {
        onSuccess(data) {
          setClientSecret(data.message);
        },
      }
    );
  }, []);

  return {
    clientSecret,
    appearance,
    stripePromise,
  };
};
